// Show popup when page loads
function initPopup() {
  const myPopup = document.getElementById('modal_popup');
  if(!myPopup) return;
  
  // Show the popup
  myPopup.classList.add('is-show');

  // Close popup when clicking close button or background
  const closeElements = document.getElementsByClassName('js-modal-close');
  for(let i = 0; i < closeElements.length; i++) {
    closeElements[i].addEventListener('click', function() {
      myPopup.classList.remove('is-show');
    });
  }
}

// Run when page is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPopup);
} else {
  initPopup();
}